import { createSvgIcon } from '@mui/material';

const IconArrowBack = createSvgIcon(
  <path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z" />,
  'arrow_back',
);

export default IconArrowBack;
